export const BUILDWEALTH_INVESTMENT_OPTIONS = [
  {
    label: "SIP",
    value: "buildwealth",
    eventValue: "sip",
  },
  {
    label: "Lumpsum",
    value: "buildwealthot",
    eventValue: "lumpsum",
  },
];

export const SAVETAX_INVESTMENT_OPTIONS = [
  {
    label: "SIP",
    value: "savetaxsip",
    eventValue: "sip",
  },
  {
    label: "Lumpsum",
    value: "savetax",
    eventValue: "lumpsum",
  },
];

export const INVESTSURPLUS_INVESTMENT_OPTIONS = [
  {
    label: "0-1 year",
    value: "1Y",
    term: 1,
    eventValue: "0-1 year",
  },
  {
    label: "1-3 years",
    value: "3Y",
    term: 3,
    eventValue: "1-3 years",
  },
];
